module.exports = __webpack_public_path__ + "static/water.9130e59e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/water.jpg
// module id = 1722
// module chunks = 35783957827783